import regionsController from './regionsController'

export default regionsController



// WEBPACK FOOTER //
// ../src/controllers/regionsController/index.js